// extracted by mini-css-extract-plugin
module.exports = {"secondaryParentItem":"LoadingComponent_secondaryParentItem__3Uy3K","basicClass":"LoadingComponent_basicClass__2QdKH"};